import React, { Fragment } from 'react';

import PaymentMethodBugs from 'components/Core/Payment/PaymentMethod/PaymentMethodBugs/PaymentMethodBugs';
import SavePaymentMethodCTA from 'components/Core/Payment/PaymentMethod/SavePaymentMethod/SavePaymentMethodCTA/SavePaymentMethodCTA';
import { FrictionlessCheckout } from 'components/Shared/FrictionlessCheckout/FrictionlessCheckout';
import { isExternalPaymentMethodSelectedSelector } from 'store/payment/selectors';
import { useSelector } from 'store/utils';
import { breakpoints } from 'styles/cp';

interface PaymentFooterProps {
  shouldShowSavePaymentMethodCta: boolean;
  isAddingCard: boolean;
  enabledPaymentMethods: string[];
  enabledCCTypes: string[];
  cdn: string;
  isFrictionlessCheckoutEnabled: boolean;
  updateFrictionlessLoginCountry?: (country: Record<string, any>) => void;
  shouldShowSaveToMerchantWalletCheckbox?: boolean;
}
const PaymentFooter: React.FC<PaymentFooterProps> = ({
  shouldShowSavePaymentMethodCta,
  isAddingCard,
  enabledPaymentMethods,
  enabledCCTypes,
  cdn,
  isFrictionlessCheckoutEnabled,
  updateFrictionlessLoginCountry,
  shouldShowSaveToMerchantWalletCheckbox,
}) => {
  const isExternalPaymentMethodSelected = useSelector(isExternalPaymentMethodSelectedSelector);

  if (
    isFrictionlessCheckoutEnabled &&
    !isExternalPaymentMethodSelected &&
    !shouldShowSaveToMerchantWalletCheckbox
  ) {
    return (
      <FrictionlessCheckout
        updateFrictionlessLoginCountry={updateFrictionlessLoginCountry}
        cdn={cdn}
      />
    );
  }

  return (
    <Fragment>
      {(shouldShowSavePaymentMethodCta || isAddingCard) && (
        <div className="payment-method-footer">
          {shouldShowSavePaymentMethodCta && (
            <div className="save-payment-method">
              <SavePaymentMethodCTA />
            </div>
          )}
          {isAddingCard && (
            <PaymentMethodBugs
              enabledPaymentMethods={enabledPaymentMethods}
              enabledCCTypes={enabledCCTypes}
              cdn={cdn}
            />
          )}
        </div>
      )}
      <style jsx>{`
        .payment-method-footer {
          padding: 8px 0 24px;
          display: flex;
          justify-content: space-between;

          @media screen and (max-width: ${breakpoints.md}) {
            flex-direction: column;
            align-items: center;
            gap: 8px;
          }

          .save-payment-method > div {
            display: inline-flex;
          }
        }
      `}</style>
    </Fragment>
  );
};

export { PaymentFooter };
